<template>

  <div class="container-fluid">
    <hr>
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.adminpanel.year.name')}}:</label>
        <div class="col-sm-10">
          <input @keyup.enter="createNewYear" type="text" class="form-control" v-model="nameOfYear">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2" for="requiredFields">{{$t('pages.adminpanel.year.editRequiredFields')}}:</label>
        <div class="col-sm-10">
          <form>
            <label class="checkbox-inline" v-for="(field, id) in possibleRequiredFields">
              <input type="checkbox" v-model="field.checked">{{$t('pages.requiredField.' + field.name)}}
            </label>
          </form>
          <!--<input @keyup.enter="save" type="text" id='requiredFields' class="form-control" v-model="year_name">-->
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.adminpanel.year.archived')}}:</label>
        <div class="col-sm-10">
          <form>
            <label class="checkbox-inline">
              <input v-model="visibleYear" type="checkbox"> {{$t('pages.adminpanel.year.archived')}}
            </label>
          </form>
          <!--<input @keyup.enter="save" type="text" id='requiredFields' class="form-control" v-model="year_name">-->
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button @click.prevent.stop="createNewYear" class="btn btn-app pull-right">
            <i class="fa fa-plus"></i>{{Add}}
          </button>
        </div>
        <div class="col-sm-offset-2 col-sm-10">
          <div class="pull-right">
            <a class="btn btn-box-tool" @click.prevent.stop="closeDropdown()">
              <i class="fa fa-caret-up"></i>
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
  // import router from './../../router/router'
  import Rest from './../../services/rest'
  // import { mapState } from 'vuex'

  export default {
    data () {
      return {
        visibleYear: false,
        nameOfYear: '', // requied
        Add: this.$t('pages.buttons.add'),
        possibleRequiredFields: [
          {name: 'firstName'},
          {name: 'lastName'},
          {name: 'studentId'},
          {name: 'allowUseOfMyResults'},
          {name: 'username'},
          {name: 'profilePictureUrl'}]
      }
    },
    props: ['year'],
    methods: {
      createNewYear () {
        var requiredFields = []
        for (var i in this.possibleRequiredFields) {
          if (this.possibleRequiredFields[i].checked) {
            requiredFields.push(this.possibleRequiredFields[i].name)
          }
        }
        var postdata = {
          groupId: this.year.groupId,
          name: this.nameOfYear,
          visible: !this.visibleYear,
          requiredFields: requiredFields
        }
        if (this.nameOfYear === '' && !this.visibleYear) {
          this.$store.commit('toggleCreateYear')
          return
        }
        return Rest.request('POST', '/years', postdata).then((data) => {
          this.Add = this.$t('pages.buttons.success')
          this.year.showEditYear = false
          console.log(('ajga'))
          this.$store.dispatch('getGroupsNew')
          // this.$store.commit('updateSelectedYear')
          console.log(data)
        }).catch((err) => {
          this.Add = this.$t('pages.buttons.fail')
          console.log(err)
        })
      },
      closeDropdown () {
        if (this.isPanel) this.$store.commit('toggleCreateYear')
        else this.$set(this.year, 'showCreateYear', !this.year.showCreateYear)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateYear.vue?13261eda